// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-for-creators-tsx": () => import("./../../../src/pages/for-creators.tsx" /* webpackChunkName: "component---src-pages-for-creators-tsx" */),
  "component---src-pages-for-users-tsx": () => import("./../../../src/pages/for-users.tsx" /* webpackChunkName: "component---src-pages-for-users-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-levis-tsx": () => import("./../../../src/pages/levis.tsx" /* webpackChunkName: "component---src-pages-levis-tsx" */),
  "component---src-pages-pricing-tsx": () => import("./../../../src/pages/pricing.tsx" /* webpackChunkName: "component---src-pages-pricing-tsx" */)
}

